
export enum UserType {
    Fleet = 0,
    InternalUser = 1,
    Engineer = 2
}
export enum AccountUserType {
    Admin = 0,
    User = 1
}

export enum UserStatus {
    Active = 0,
    Inactive = 1
}
